/**
 * Module dependencies.
 */

import 'normalize.css';
import '@fontsource/montserrat';
import '@fontsource/inter/100.css';
import '@fontsource/inter/200.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import 'yet-another-react-lightbox/styles.css';
import { css } from '@emotion/react';

/**
 * Export `globalStyle` component.
 */

export const globalStyle = css`
  * {
    box-sizing: border-box;
  }

  html,
  body {
    width: 100vw;
    height: 100vh;
    overscroll-behavior: none;
    overflow-x: hidden;
  }

  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    background-color: white;
    color: black;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  html {
    font-family: 'Montserrat', sans-serif;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  svg {
    display: block;
  }
`;
